import getStore from 'services/getStore';
import pubSub from 'services/pubSub';
import isAndroidSamsung from 'services/isAndroidSamsung';
import isAppleComputerInc from 'services/isAppleComputerInc';
import {
  getModuleIsFreeScrollingDesktop,
  getModuleIsFreeScrollingDevice,
} from 'services/getModuleIsFreeScrolling';
import { reviewToolPostMessage } from 'services/reviewToolPostMessage';
import { speechSynthesisCancel } from 'services/speechSynthesisCancel';
import { getSCORMInitialized } from 'components/lib/Scorm/SCORM';

const store = getStore();

const isDevice = isAppleComputerInc() || isAndroidSamsung();

let interactionsSeen = [] as any[];

pubSub.subscribe('RESET_MODULE', () => {
  interactionsSeen = [];
});

let debounceScrolling;

let oldTopic;
let newTopic;
let topicUpdated;

let oldPosition = 0;
let newPosition = 0;

const clearHistory = () => {
  requestAnimationFrame(
    () =>
      (window.location.hash = Math.random()
        .toString(16)
        .substr(2, 8))
  );
  (window as any).locationHistory = null;
};

// when the pattern settles. all this will just publish an object with
// all this

const windowScrollInfo = (e, currentTopic) => {
  if (currentTopic) {
    newTopic = currentTopic;
  }

  clearTimeout(debounceScrolling);

  debounceScrolling = setTimeout(() => {
    let scrollDirection;

    const sections = Array.from(document.querySelectorAll('section'));

    if (oldTopic !== newTopic) {
      topicUpdated = true;
      oldTopic = newTopic;
    } else {
      topicUpdated = false;
    }

    if (!topicUpdated) {
      newPosition = window.scrollY;

      if (oldPosition !== newPosition) {
        scrollDirection = oldPosition < newPosition ? 'down' : 'up';

        // either direction. might change. us direction for other things. . .
        if (
          window.locationHistory &&
          ['up', 'down'].includes(scrollDirection)
        ) {
          //
          // if persistHistory ( false by default ) is true we do not want to clear it automatically here on scroll
          // do not clear history if we've landed in a topic with only a single interaction
          //

          if (!window.persistHistory && sections?.length !== 1) {
            clearHistory();
          }
        }

        oldPosition = newPosition;
      }
    }

    const sectionsInView: any = sections.reduce(
      ((acc, curr, index) => {
        const { top, height } = curr.getBoundingClientRect();

        return [
          ...acc,
          {
            section: curr,
            id: curr.id.replace(/i/, ''),
            inView: height
              ? top >= 0 - height / 2 && top <= window.innerHeight / 2
              : false,
            index,
          },
        ];
      }) as any,
      []
    );

    const sectionInView = sectionsInView.find(s => s.inView);

    if (sectionInView && window['sectionInView']?.id !== sectionInView?.id) {
      // console.log(
      //   'only update sectionInView if defined and it changes !!!',
      //   sectionInView.id
      // );

      window['sectionInView'] = sectionInView;

      speechSynthesisCancel();

      // moving the focus biz back to the continue / back button. . .
      sections.forEach(section => {
        //
        //
        if (!isDevice) {
          // if we on desktop && we not freeScrolling
          if (!getModuleIsFreeScrollingDesktop()) {
            //
            if (window?.dev && !window.dev()) {
              section.setAttribute('inert', '');
            }

            section.removeAttribute('role');
          }
        }
      });

      if (sectionInView) {
        if (!isDevice) {
          // if we on desktop && we not freeScrolling
          if (!getModuleIsFreeScrollingDesktop()) {
            sectionInView.section.removeAttribute('inert');
            //
            sectionInView.section.setAttribute('role', 'main');
          }
        } else {
          // we are on a device. check if we freeScrolling
          if (!getModuleIsFreeScrollingDevice()) {
            const { activeElement } = document;
            const activeElementIsInput =
              activeElement &&
              ['input', 'textarea'].indexOf(
                activeElement.tagName.toLowerCase()
              ) !== -1;

            // only give focus back to section if..
            if (!activeElementIsInput) {
              sectionInView.section.focus({
                preventScroll: true,
              });
            }
          }
        }

        pubSub.publish('SECTION_IN_VIEW', {
          sectionInView,
        });

        // console.log('SCORM INITIALIZED ?', getSCORMInitialized());
        // only fire if we're not connected to scorm
        // window.reviewModeEnabled &&
        if (!getSCORMInitialized()) {
          reviewToolPostMessage({
            type: 'currentInteractionId',
            data: sectionInView.id,
          });
        }
      }
    }

    if (!window['sectionInView']) {
      return;
    }

    if (!interactionsSeen.includes(window['sectionInView'].id)) {
      interactionsSeen.push(window['sectionInView'].id);

      store.dispatch({
        type: 'UPDATE_INTERACTIONS_SEEN',
        data: {
          id: window['sectionInView'].id,
        },
      });
    }
  }, 100);
};

window.addEventListener('scroll', e => windowScrollInfo(e, null));

export default windowScrollInfo;
